// extracted by mini-css-extract-plugin
module.exports = {"root":"DashboardPage_root__1k_NU"};